import React from 'react'
import './style.css'

export default function DownloadButtons({ className, ios = false, android = false }) {
  ios = ios  || "https://itunes.apple.com/ca/app/kinzoo-messenger-for-kids/id1453081302"
  android = android  || "https://play.google.com/store/apps/details?id=com.kinzoo.android"

  return (
    <div className={`early-access__fieldset flex ${className}`}>
      <a
        href={ios}
        target="_blank"
        className=" flex-item reset"
      >
        <img
          src="/download-app-store.png"
          className="download download--apple"
          alt="download on the app store"
        />
      </a>
      <a
        href={android}
        target="_blank"
        className=" flex-item reset"
      >
        <img
          src="/download-google-play.png"
          className="download download--google"
          alt="get it on Google Play"
        />
      </a>
    </div>
  )
}
